import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WorkspaceSelector from "./WorkspaceSelector";
import UserProfileButton from "./UserProfileButton";

import SearchBar from "./SearchBar";
import logoLight from "assets/img/dashboards/logoLight.png";

const BetaNavbar = ({
  selectedWorkspaceId,
  onWorkspaceChange,
  workspaces = [],
  onWorkspacesRefresh,
  hideWorkspaceSelector = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    // Navigate to /v2 which will redirect to the default workspace
    navigate("/v2");
  };

  const handleWorkspaceChange = (workspaceId) => {
    onWorkspaceChange?.(workspaceId);
  };

  const handleWorkspaceCreated = () => {
    // Trigger parent to refresh workspaces
    onWorkspacesRefresh?.();
  };

  return (
    <header className="border-black/[0.06] sticky top-0 z-50 flex h-[72px] items-center justify-between border-b bg-white px-10">
      {/* Left section: Logo + Workspace */}
      <div className="flex items-center gap-6">
        {/* Logo */}
        <button
          onClick={handleLogoClick}
          className="transition-opacity duration-150 hover:opacity-80 focus:outline-none"
        >
          <img
            src={logoLight}
            alt={t("navigation.navbar.logoAlt")}
            className="h-12"
          />
        </button>

        {!hideWorkspaceSelector && (
          <>
            {/* Divider */}
            <div className="h-7 w-px bg-[#E5E7EB]" />

            {/* Workspace Selector */}
            <WorkspaceSelector
              workspaces={workspaces}
              selectedWorkspaceId={selectedWorkspaceId}
              onWorkspaceChange={handleWorkspaceChange}
              onWorkspaceCreated={handleWorkspaceCreated}
            />
          </>
        )}
      </div>

      {/* Right section: Search, Notifications, User */}
      <div className="flex items-center gap-2">
        {/* Search: opens the command palette (also Cmd/Ctrl+K) */}
        <SearchBar
          workspaceId={hideWorkspaceSelector ? null : selectedWorkspaceId}
        />

        {/* Divider */}
        <div className="mx-2 h-7 w-px bg-[#E5E7EB]" />

        {/* User Profile */}
        <UserProfileButton
          role={
            workspaces?.find(
              (w) => String(w.id) === String(selectedWorkspaceId)
            )?.role
          }
        />
      </div>
    </header>
  );
};

export default BetaNavbar;
